/* eslint-disable react/no-danger */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable simple-import-sort/imports */
/* eslint-disable max-len */
import { useRef, forwardRef, useImperativeHandle } from 'react';

import useStyles from './style';
import { Button, Grid, Typography } from '@material-ui/core';
import { dataPreference, publicImgMajorTest, publicSvgPath } from '@orientaction/utils';
import dateFormat from 'dateformat';
import SliderScore from '@orientaction/components/SliderScore';

export interface ResultatPDFHandle {
  handleDownload: () => Promise<void>;
}

const ResultatPDF = forwardRef<ResultatPDFHandle, { myResult: any }>(({ myResult }, ref) => {
  const classes = useStyles({});
  const contentRef = useRef<HTMLDivElement>(null);

  const handleDownload = async () => {
    if (!contentRef.current) {
      return;
    }

    const { default: html2pdf } = await import('html2pdf.js');

    const options = {
      margin: [0, 0, 0, 0], // Pas de marge externe, la mise en page est gérée par le padding interne
      filename: `Résultat Préférences® test des 32 personnalités - ${myResult?.user?.firstname || ''} ${myResult?.user?.lastname || ''}.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: {
        scale: 2,
        useCORS: true,
        logging: false,
        letterRendering: true,
        backgroundColor: '#FFF', // Fond blanc comme le conteneur PDF
        removeContainer: true,
        allowTaint: true,
      },
      jsPDF: {
        unit: 'px',
        // Format A4 en pixels à ~150 DPI : 1240px × 1754px (210mm × 297mm)
        format: [1240, 1754],
        orientation: 'portrait',
        compress: true,
      },
      pagebreak: {
        mode: ['css', 'legacy'],
        before: '.page-break-before',
        after: '.page-break-after',
      },
    } as any;

    html2pdf().set(options).from(contentRef.current).save();
  };

  useImperativeHandle(ref, () => ({
    handleDownload,
  }));

  return (
    <div className={classes.wrapper}>
      <div ref={contentRef} className={classes.page}>
        <div className={classes.header}>
          <Typography variant="h2" className={classes.titleHeader} style={{ margin: 0 }}>
            Préférences®, test des 32 personnalités
          </Typography>
        </div>
        <div className="page-break-after" style={{ padding: '80px 80px 0px 80px' }}>
          <div className={classes.imgBanner}>
            <img src={`${publicImgMajorTest}/banniere_pref.png`} alt="couverture intro" />
          </div>
          <div className={classes.info}>
            <div className={classes.infoContent}>
              Nom du test : <span>Préférences®, test des 32 personnalités</span>
            </div>
            <div className={classes.infoContent}>
              Bénéficiaire :{' '}
              <span>
                {myResult?.user?.firstname} {myResult?.user?.lastname}
              </span>
            </div>
            <div className={classes.infoContent}>
              Date de passation :{' '}
              <span>
                {myResult?.initValue?.realization_date &&
                  dateFormat(new Date(myResult?.initValue?.realization_date), 'dd/mm/yyyy')}
              </span>
            </div>
            <div className={classes.infoContent}>
              Consultant :{' '}
              <span>
                {myResult?.consultant?.firstname} {myResult?.consultant?.lastname}
              </span>
            </div>
            <div className={classes.infoContent}>
              Validation :{' '}
              <span style={{ color: myResult?.updatedDate ? '#22C55E' : '#E0E0E0' }}>
                {myResult?.updatedDate ? 'Oui' : 'Non'}
              </span>
            </div>
            <div className={classes.infoContent}>
              Date de validation :{' '}
              <span>
                {myResult?.updatedDate && dateFormat(new Date(myResult?.updatedDate), 'dd/mm/yyyy')}
              </span>
            </div>
          </div>
        </div>
        <div style={{ padding: '40px 80px 80px 80px' }}>
          <div className={`${classes.section} page-break-after`}>
            <h2 className={`${classes.heading} ${classes.h1}`}>Synthèse de vos résultats</h2>
            <div className={classes.sliderScore}>
              <div className={classes.sliderScoreItem}>
                {myResult?.resultat?.map((elem: any, index: number) => (
                  <SliderScore key={(elem.key || elem.title) ?? index} pref={elem} isEdit={false} isCanceled={false} forPDF={true} />
                ))}
              </div>
            </div>
            <div>
              <h2 className={`${classes.heading} ${classes.h4}`}>Vos 5 préférences</h2>
              <p className={classes.paragraph} style={{fontSize: 24, fontWeight: 700, lineHeight: 1.4,}}>
                Voici vos cinq préférences dans votre personnalité profonde. La personnalité
                profonde correspond à votre manière de penser et de se comporter quand vous n’êtes
                soumis(e) à aucune contrainte.
              </p>
              <p className={classes.paragraph} style={{fontSize: 24, fontWeight: 700, lineHeight: 1.4,}}>
                L’objectif est de trouver un métier et un environnement professionnel qui permettent
                d’exprimer vos préférences profondes. Bref, qui vous permettent d’être vous-même.
                Cela est aussi vrai dans votre vie personnelle.
              </p>
              <Grid container={true} spacing={2} alignItems="center" justifyContent="center" style={{ marginTop: 70 }}>
                {myResult?.resultat?.map((elem: any) => (
                  <Grid item={true} xs={4} key={elem.category}>
                    <Button
                      key={elem.category}
                      variant="contained"
                      style={{
                        background: dataPreference[elem.category].color,
                        color: 'white',
                        width: '100%',
                        height: 70,
                        fontSize: 20,
                        borderRadius: 15
                      }}
                      disableElevation={true}>
                      {elem.label}
                    </Button>
                  </Grid>
                ))}
              </Grid>
            </div>
          </div>

          <div className={`${classes.section} page-break-after`} style={{ paddingTop: 80 }}>
            <div className={classes.score}>
              {myResult?.resultat[0]?.label}{' '}
              <span>
                {' '}
                {myResult?.resultat[0]?.score[0]?.isMax
                  ? myResult?.resultat[0]?.score[0]?.pourcentage
                  : myResult?.resultat[0]?.score[1]?.pourcentage}
              </span>
              <span>%</span>
            </div>

            <h2 className={`${classes.heading} ${classes.h2}`}>{myResult?.resultat[0]?.title}</h2>
            <div style={{ fontSize: 24, fontWeight: 700, fontFamily: 'Poppins', lineHeight: 1.4 }}>
              Vous êtes {myResult?.resultat[0]?.youAre}
            </div>

            <div className={classes.imgWhiteBanner}>
              <img
                src={`${publicSvgPath}/${
                  myResult?.resultat[0] &&
                  dataPreference[myResult?.resultat[0]?.category][myResult?.resultat[0]?.key]?.img
                }`}
                alt=""
              />
            </div>

            <h2 className={`${classes.heading} ${classes.h6}`}>Votre style général</h2>
            <p
              className={classes.paragraph}
              style={{ fontWeight: 400 }}
              dangerouslySetInnerHTML={{
                __html:
                  myResult?.resultat[0] &&
                  dataPreference[myResult?.resultat[0]?.category][myResult?.resultat[0]?.key]
                    ?.text1,
              }}
            />

            <h2 className={`${classes.heading} ${classes.h6}`}>Vos relations avec les autres</h2>
            <p
              className={classes.paragraph}
              style={{ fontWeight: 400 }}
              dangerouslySetInnerHTML={{
                __html:
                  myResult?.resultat[0] &&
                  dataPreference[myResult?.resultat[0]?.category][myResult?.resultat[0]?.key]
                    ?.text2,
              }}
            />
          </div>
          <div className={`${classes.section} page-break-after`} style={{ paddingTop: 40 }}>
            <h2 className={`${classes.heading} ${classes.h6}`}>Ce qui vous stimule</h2>
            {myResult?.resultat[0] &&
            dataPreference[myResult?.resultat[0]?.category][myResult?.resultat[0]?.key]
              ?.listText ? (
              <p
                className={classes.paragraph}
                style={{ fontWeight: 400 }}
                dangerouslySetInnerHTML={{
                  __html:
                    dataPreference[myResult?.resultat[0]?.category][myResult?.resultat[0]?.key]
                      ?.list1,
                }}
              />
            ) : (
              <ul className={classes.listUl}>
                {myResult?.resultat[0] &&
                  dataPreference[myResult?.resultat[0]?.category][
                    myResult?.resultat[0]?.key
                  ]?.list1?.map((elem: any) => (
                    <li key={elem} className={classes.listLi}>
                      <Typography
                        variant="body2"
                        component="p"
                        dangerouslySetInnerHTML={{
                          // eslint-disable-next-line react/destructuring-assignment
                          __html: elem,
                        }}
                      />
                    </li>
                  ))}
              </ul>
            )}
            <h2 className={`${classes.heading} ${classes.h6}`} style={{ marginTop: 50 }}>Ce qui vous épuise</h2>
            <ul className={classes.listUl}>
              {myResult?.resultat[0] &&
                dataPreference[myResult?.resultat[0]?.category][
                  myResult?.resultat[0]?.key
                ]?.list2?.map((elem: any) => (
                  <li key={elem} className={classes.listLi}>
                    <Typography
                      variant="body2"
                      component="p"
                      dangerouslySetInnerHTML={{
                        // eslint-disable-next-line react/destructuring-assignment
                        __html: elem,
                      }}
                    />
                  </li>
                ))}
            </ul>
          </div>

          <div className={`${classes.section} page-break-after`} style={{ paddingTop: 80 }}>
            <div className={classes.score}>
              {myResult?.resultat[1]?.label}{' '}
              <span>
                {' '}
                {myResult?.resultat[1]?.score[0]?.isMax
                  ? myResult?.resultat[1]?.score[0]?.pourcentage
                  : myResult?.resultat[1]?.score[1]?.pourcentage}
              </span>
              <span>%</span>
            </div>

            <h2 className={`${classes.heading} ${classes.h2}`}>{myResult?.resultat[1]?.title}</h2>
            <div style={{ fontSize: 24, fontWeight: 700, fontFamily: 'Poppins', lineHeight: 1.4 }}>
              Vous êtes {myResult?.resultat[1]?.youAre}
            </div>

            <div className={classes.imgWhiteBanner}>
              <img
                src={`${publicSvgPath}/${
                  myResult?.resultat[1] &&
                  dataPreference[myResult?.resultat[1]?.category][myResult?.resultat[1]?.key]?.img
                }`}
                alt=""
              />
            </div>

            <h2 className={`${classes.heading} ${classes.h6}`}>Votre style général</h2>
            <p
              className={classes.paragraph}
              style={{ fontWeight: 400 }}
              dangerouslySetInnerHTML={{
                __html:
                  myResult?.resultat[1] &&
                  dataPreference[myResult?.resultat[1]?.category][myResult?.resultat[1]?.key]
                    ?.text1,
              }}
            />

            <h2 className={`${classes.heading} ${classes.h6}`}>Vos relations avec les autres</h2>
            <p
              className={classes.paragraph}
              style={{ fontWeight: 400 }}
              dangerouslySetInnerHTML={{
                __html:
                  myResult?.resultat[1] &&
                  dataPreference[myResult?.resultat[1]?.category][myResult?.resultat[1]?.key]
                    ?.text2,
              }}
            />
          </div>
          <div className={`${classes.section} page-break-after`} style={{ paddingTop: 40 }}>
            <h2 className={`${classes.heading} ${classes.h6}`}>Ce qui vous stimule</h2>
            {myResult?.resultat[1] &&
            dataPreference[myResult?.resultat[1]?.category][myResult?.resultat[1]?.key]
              ?.listText ? (
              <p
                className={classes.paragraph}
                style={{ fontWeight: 400 }}
                dangerouslySetInnerHTML={{
                  __html:
                    dataPreference[myResult?.resultat[1]?.category][myResult?.resultat[1]?.key]
                      ?.list1,
                }}
              />
            ) : (
              <ul className={classes.listUl}>
                {myResult?.resultat[1] &&
                  dataPreference[myResult?.resultat[1]?.category][
                    myResult?.resultat[1]?.key
                  ]?.list1?.map((elem: any) => (
                    <li key={elem} className={classes.listLi}>
                      <Typography
                        variant="body2"
                        component="p"
                        dangerouslySetInnerHTML={{
                          // eslint-disable-next-line react/destructuring-assignment
                          __html: elem,
                        }}
                      />
                    </li>
                  ))}
              </ul>
            )}
            <h2 className={`${classes.heading} ${classes.h6}`} style={{ marginTop: 50 }}>Ce qui vous épuise</h2>
            <ul className={classes.listUl}>
              {myResult?.resultat[1] &&
                dataPreference[myResult?.resultat[1]?.category][
                  myResult?.resultat[1]?.key
                ]?.list2?.map((elem: any) => (
                  <li key={elem} className={classes.listLi}>
                    <Typography
                      variant="body2"
                      component="p"
                      dangerouslySetInnerHTML={{
                        // eslint-disable-next-line react/destructuring-assignment
                        __html: elem,
                      }}
                    />
                  </li>
                ))}
            </ul>
          </div>

          <div className={`${classes.section} page-break-after`} style={{ paddingTop: 80 }}>
            <div className={classes.score}>
              {myResult?.resultat[2]?.label}{' '}
              <span>
                {' '}
                {myResult?.resultat[2]?.score[0]?.isMax
                  ? myResult?.resultat[2]?.score[0]?.pourcentage
                  : myResult?.resultat[2]?.score[1]?.pourcentage}
              </span>
              <span>%</span>
            </div>

            <h2 className={`${classes.heading} ${classes.h2}`}>{myResult?.resultat[2]?.title}</h2>
            <div style={{ fontSize: 24, fontWeight: 700, fontFamily: 'Poppins', lineHeight: 1.4 }}>
              Vous êtes {myResult?.resultat[2]?.youAre}
            </div>

            <div className={classes.imgWhiteBanner}>
              <img
                src={`${publicSvgPath}/${
                  myResult?.resultat[2] &&
                  dataPreference[myResult?.resultat[2]?.category][myResult?.resultat[2]?.key]?.img
                }`}
                alt=""
              />
            </div>

            <h2 className={`${classes.heading} ${classes.h6}`}>Votre style général</h2>
            <p
              className={classes.paragraph}
              style={{ fontWeight: 400 }}
              dangerouslySetInnerHTML={{
                __html:
                  myResult?.resultat[2] &&
                  dataPreference[myResult?.resultat[2]?.category][myResult?.resultat[2]?.key]
                    ?.text1,
              }}
            />

            <h2 className={`${classes.heading} ${classes.h6}`}>Vos relations avec les autres</h2>
            <p
              className={classes.paragraph}
              style={{ fontWeight: 400 }}
              dangerouslySetInnerHTML={{
                __html:
                  myResult?.resultat[2] &&
                  dataPreference[myResult?.resultat[2]?.category][myResult?.resultat[2]?.key]
                    ?.text2,
              }}
            />
          </div>
          <div className={`${classes.section} page-break-after`} style={{ paddingTop: 40 }}>
            <h2 className={`${classes.heading} ${classes.h6}`}>Ce qui vous stimule</h2>
            {myResult?.resultat[2] &&
            dataPreference[myResult?.resultat[2]?.category][myResult?.resultat[2]?.key]
              ?.listText ? (
              <p
                className={classes.paragraph}
                style={{ fontWeight: 400 }}
                dangerouslySetInnerHTML={{
                  __html:
                    dataPreference[myResult?.resultat[2]?.category][myResult?.resultat[2]?.key]
                      ?.list1,
                }}
              />
            ) : (
              <ul className={classes.listUl}>
                {myResult?.resultat[2] &&
                  dataPreference[myResult?.resultat[2]?.category][
                    myResult?.resultat[2]?.key
                  ]?.list1?.map((elem: any) => (
                    <li key={elem} className={classes.listLi}>
                      <Typography
                        variant="body2"
                        component="p"
                        dangerouslySetInnerHTML={{
                          // eslint-disable-next-line react/destructuring-assignment
                          __html: elem,
                        }}
                      />
                    </li>
                  ))}
              </ul>
            )}
            <h2 className={`${classes.heading} ${classes.h6}`} style={{ marginTop: 50 }}>Ce qui vous épuise</h2>
            <ul className={classes.listUl}>
              {myResult?.resultat[2] &&
                dataPreference[myResult?.resultat[2]?.category][
                  myResult?.resultat[2]?.key
                ]?.list2?.map((elem: any) => (
                  <li key={elem} className={classes.listLi}>
                    <Typography
                      variant="body2"
                      component="p"
                      dangerouslySetInnerHTML={{
                        // eslint-disable-next-line react/destructuring-assignment
                        __html: elem,
                      }}
                    />
                  </li>
                ))}
            </ul>
          </div>

          <div className={`${classes.section} page-break-after`} style={{ paddingTop: 80 }}>
            <div className={classes.score}>
              {myResult?.resultat[3]?.label}{' '}
              <span>
                {' '}
                {myResult?.resultat[3]?.score[0]?.isMax
                  ? myResult?.resultat[3]?.score[0]?.pourcentage
                  : myResult?.resultat[3]?.score[1]?.pourcentage}
              </span>
              <span>%</span>
            </div>

            <h2 className={`${classes.heading} ${classes.h2}`}>{myResult?.resultat[3]?.title}</h2>
            <div style={{ fontSize: 24, fontWeight: 700, fontFamily: 'Poppins', lineHeight: 1.4 }}>
              Vous êtes {myResult?.resultat[3]?.youAre}
            </div>

            <div className={classes.imgWhiteBanner}>
              <img
                src={`${publicSvgPath}/${
                  myResult?.resultat[3] &&
                  dataPreference[myResult?.resultat[3]?.category][myResult?.resultat[3]?.key]?.img
                }`}
                alt=""
              />
            </div>

            <h2 className={`${classes.heading} ${classes.h6}`}>Votre style général</h2>
            <p
              className={classes.paragraph}
              style={{ fontWeight: 400 }}
              dangerouslySetInnerHTML={{
                __html:
                  myResult?.resultat[3] &&
                  dataPreference[myResult?.resultat[3]?.category][myResult?.resultat[3]?.key]
                    ?.text1,
              }}
            />

            <h2 className={`${classes.heading} ${classes.h6}`}>Vos relations avec les autres</h2>
            <p
              className={classes.paragraph}
              style={{ fontWeight: 400 }}
              dangerouslySetInnerHTML={{
                __html:
                  myResult?.resultat[3] &&
                  dataPreference[myResult?.resultat[3]?.category][myResult?.resultat[3]?.key]
                    ?.text2,
              }}
            />
          </div>
          <div className={`${classes.section} page-break-after`} style={{ paddingTop: 40 }}>
            <h2 className={`${classes.heading} ${classes.h6}`}>Ce qui vous stimule</h2>
            {myResult?.resultat[3] &&
            dataPreference[myResult?.resultat[3]?.category][myResult?.resultat[3]?.key]
              ?.listText ? (
              <p
                className={classes.paragraph}
                style={{ fontWeight: 400 }}
                dangerouslySetInnerHTML={{
                  __html:
                    dataPreference[myResult?.resultat[3]?.category][myResult?.resultat[3]?.key]
                      ?.list1,
                }}
              />
            ) : (
              <ul className={classes.listUl}>
                {myResult?.resultat[3] &&
                  dataPreference[myResult?.resultat[3]?.category][
                    myResult?.resultat[3]?.key
                  ]?.list1?.map((elem: any) => (
                    <li key={elem} className={classes.listLi}>
                      <Typography
                        variant="body2"
                        component="p"
                        dangerouslySetInnerHTML={{
                          // eslint-disable-next-line react/destructuring-assignment
                          __html: elem,
                        }}
                      />
                    </li>
                  ))}
              </ul>
            )}
            <h2 className={`${classes.heading} ${classes.h6}`} style={{ marginTop: 50 }}>Ce qui vous épuise</h2>
            <ul className={classes.listUl}>
              {myResult?.resultat[3] &&
                dataPreference[myResult?.resultat[3]?.category][
                  myResult?.resultat[3]?.key
                ]?.list2?.map((elem: any) => (
                  <li key={elem} className={classes.listLi}>
                    <Typography
                      variant="body2"
                      component="p"
                      dangerouslySetInnerHTML={{
                        // eslint-disable-next-line react/destructuring-assignment
                        __html: elem,
                      }}
                    />
                  </li>
                ))}
            </ul>
          </div>

          <div className={`${classes.section} page-break-after`} style={{ paddingTop: 80 }}>
            <div className={classes.score}>
              {myResult?.resultat[4]?.label}{' '}
              <span>
                {' '}
                {myResult?.resultat[4]?.score[0]?.isMax
                  ? myResult?.resultat[4]?.score[0]?.pourcentage
                  : myResult?.resultat[4]?.score[1]?.pourcentage}
              </span>
              <span>%</span>
            </div>

            <h2 className={`${classes.heading} ${classes.h2}`}>{myResult?.resultat[4]?.title}</h2>
            <div style={{ fontSize: 24, fontWeight: 700, fontFamily: 'Poppins', lineHeight: 1.4 }}>
              Vous êtes {myResult?.resultat[4]?.youAre}
            </div>

            <div className={classes.imgWhiteBanner}>
              <img
                src={`${publicSvgPath}/${
                  myResult?.resultat[4] &&
                  dataPreference[myResult?.resultat[4]?.category][myResult?.resultat[4]?.key]?.img
                }`}
                alt=""
              />
            </div>

            <h2 className={`${classes.heading} ${classes.h6}`}>Votre style général</h2>
            <p
              className={classes.paragraph}
              style={{ fontWeight: 400 }}
              dangerouslySetInnerHTML={{
                __html:
                  myResult?.resultat[4] &&
                  dataPreference[myResult?.resultat[4]?.category][myResult?.resultat[4]?.key]
                    ?.text1,
              }}
            />

            <h2 className={`${classes.heading} ${classes.h6}`}>Vos relations avec les autres</h2>
            <p
              className={classes.paragraph}
              style={{ fontWeight: 400 }}
              dangerouslySetInnerHTML={{
                __html:
                  myResult?.resultat[4] &&
                  dataPreference[myResult?.resultat[4]?.category][myResult?.resultat[4]?.key]
                    ?.text2,
              }}
            />
          </div>
          <div className={`${classes.section}`} style={{ paddingTop: 40 }}>
            <h2 className={`${classes.heading} ${classes.h6}`}>Ce qui vous stimule</h2>
            {myResult?.resultat[4] &&
            dataPreference[myResult?.resultat[4]?.category][myResult?.resultat[4]?.key]
              ?.listText ? (
              <p
                className={classes.paragraph}
                style={{ fontWeight: 400 }}
                dangerouslySetInnerHTML={{
                  __html:
                    dataPreference[myResult?.resultat[4]?.category][myResult?.resultat[4]?.key]
                      ?.list1,
                }}
              />
            ) : (
              <ul className={classes.listUl}>
                {myResult?.resultat[4] &&
                  dataPreference[myResult?.resultat[4]?.category][
                    myResult?.resultat[4]?.key
                  ]?.list1?.map((elem: any) => (
                    <li key={elem} className={classes.listLi}>
                      <Typography
                        variant="body2"
                        component="p"
                        dangerouslySetInnerHTML={{
                          // eslint-disable-next-line react/destructuring-assignment
                          __html: elem,
                        }}
                      />
                    </li>
                  ))}
              </ul>
            )}
            <h2 className={`${classes.heading} ${classes.h6}`} style={{ marginTop: 50 }}>Ce qui vous épuise</h2>
            <ul className={classes.listUl}>
              {myResult?.resultat[4] &&
                dataPreference[myResult?.resultat[4]?.category][
                  myResult?.resultat[4]?.key
                ]?.list2?.map((elem: any) => (
                  <li key={elem} className={classes.listLi}>
                    <Typography
                      variant="body2"
                      component="p"
                      dangerouslySetInnerHTML={{
                        // eslint-disable-next-line react/destructuring-assignment
                        __html: elem,
                      }}
                    />
                  </li>
                ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
});

ResultatPDF.displayName = 'ResultatPDF';

export default ResultatPDF;
